export default "__VITE_ASSET__BnI_oPxA__"